import { put } from 'redux-saga/effects'
import importer from 'common/importer'
const DonorsActions = importer('Stores/Donors/Actions')
const { registerDonor } = importer('APIs/donors', null)
export default function * main ({ donor }) {
  try {
    yield put(DonorsActions.registerDonorLoading())
    const res = yield registerDonor(donor)

    yield put(DonorsActions.registerDonorSuccess(res))
  } catch (error) {
    yield put(DonorsActions.registerDonorFailure(error.response.data))
  }
}
